import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { BehaviorSubject, of } from "rxjs";
import { INDRAApiService } from "./api.indra.service";
import { tap, map } from "rxjs/operators";
import { INDRATranslationToggleService } from "@ibe.components/translation-toggle/translation-toggle.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
import * as i3 from "../components/translation-toggle/translation-toggle.service";
var INDRAIbeAdminService = /** @class */ (function () {
    function INDRAIbeAdminService(http, api, translationToggle) {
        this.http = http;
        this.api = api;
        this.translationToggle = translationToggle;
        this.loadingStates = {};
        this.ibeadmin_debug = false; // to show/hide ibeadmin texts with asterisc mark and help development
        this.translationsObj = {};
        this.translationsObjEn = {};
        this.translationsByKey = new Map();
        this.loadedModules = new Set();
        this.translationsLanguage = "";
        this.translationsENObj = {};
        this.translationsENByKey = new Map();
        this.loadedModulesEN = new Set();
    }
    INDRAIbeAdminService.prototype.loadTranslations = function (scopeId, moduleIds, language) {
        var _this = this;
        if (language.toLocaleLowerCase() !== "en") {
            this.loadTranslationsEN(scopeId, moduleIds);
        }
        var modulesToLoad = new Array();
        moduleIds.forEach(function (moduleId) {
            if (!_this.loadedModules.has(moduleId) ||
                _this.translationsLanguage != language)
                modulesToLoad.push(moduleId);
        });
        if (!this.translationsObjEn.hasOwnProperty("ancillaries")) {
            this.http
                .post(environment.api_url + "ibe/rest/scopes/" + scopeId + "/modules/translations/en", { modules: ["ancillaries"] })
                .subscribe(function (data) {
                data.forEach(function (moduleTranslations) {
                    if (_this.translationsObjEn)
                        Object.assign(_this.translationsObjEn, moduleTranslations);
                    else
                        _this.translationsObjEn = moduleTranslations;
                });
            });
        }
        if (modulesToLoad.length > 0) {
            return this.http
                .post(environment.api_url + "ibe/rest/scopes/" + scopeId + "/modules/translations/" + language, { modules: modulesToLoad })
                .subscribe(function (data) {
                data.forEach(function (moduleTranslations) {
                    if (_this.translationsObj)
                        Object.assign(_this.translationsObj, moduleTranslations);
                    else
                        _this.translationsObj = moduleTranslations;
                });
                modulesToLoad.forEach(function (moduleId) {
                    if (!_this.loadedModules.has(moduleId))
                        _this.loadedModules.add(moduleId);
                });
                Array.from(_this.translationsByKey.keys()).forEach(function (key) {
                    _this.translationsByKey.get(key).next(_this.getTranslationValue(key));
                });
                _this.translationsLanguage = language;
            });
        }
    };
    INDRAIbeAdminService.prototype.reloadTranslations = function (scopeId, language) {
        var _this = this;
        if (language.toLocaleLowerCase() !== "en") {
            this.reloadTranslationsEN(scopeId);
        }
        var moduleIds = Array.from(this.loadedModules.values());
        this.translationsLanguage = language;
        return this.http
            .post(environment.api_url + "ibe/rest/scopes/" + scopeId + "/modules/translations/" + language, { modules: moduleIds })
            .subscribe(function (data) {
            data.forEach(function (moduleTranslations) {
                if (_this.translationsObj)
                    Object.assign(_this.translationsObj, moduleTranslations);
                else
                    _this.translationsObj = moduleTranslations;
            });
            Array.from(_this.translationsByKey.keys()).forEach(function (key) {
                return _this.translationsByKey.get(key).next(_this.getTranslationValue(key));
            });
        });
    };
    INDRAIbeAdminService.prototype.getTranslationValue = function (key, ancillarieEnCode) {
        var translationsObjAux;
        if (this.translationToggle.getValue()) {
            return key;
        }
        if (ancillarieEnCode)
            translationsObjAux = this.translationsObjEn;
        else
            translationsObjAux = this.translationsObj;
        if (this.ibeadmin_debug)
            console.log("[IBE-Admin] Getting key " +
                key +
                " with language " +
                this.translationsLanguage);
        if (translationsObjAux) {
            var keyValues = key.split('.');
            var result_1 = null;
            keyValues.forEach(function (value) {
                if (result_1)
                    result_1 = result_1[value];
                else
                    result_1 = translationsObjAux[value];
            });
            if (result_1) {
                if (this.ibeadmin_debug)
                    return "*" + result_1 + "*";
                else
                    return result_1.toString();
            }
            else {
                if (this.ibeadmin_debug)
                    console.warn('[IBE-Admin] Translation key not found: "' + key + '"');
                if (this.translationsLanguage.toLocaleLowerCase() !== "en") {
                    return this.getTranslationValueEN(key);
                }
                return key;
            }
        }
        else {
            if (this.translationsLanguage.toLocaleLowerCase() !== "en") {
                return this.getTranslationValueEN(key);
            }
            return key;
        }
    };
    INDRAIbeAdminService.prototype.getTranslationValueAsync = function (key, fromPipe) {
        var _this = this;
        if (fromPipe === void 0) { fromPipe = false; }
        if (this.translationToggle.getValue()) {
            return of(key);
        }
        if (!this.translationsByKey.has(key)) {
            var result = this.getTranslationValue(key);
            this.translationsByKey.set(key, new BehaviorSubject(result));
        }
        if (fromPipe) {
            return this.translationsByKey.get(key).asObservable();
        }
        else {
            return this.translationsByKey.get(key).asObservable().pipe(tap(function (data) {
                if (data === key) {
                    _this.setLoadingState(key, true);
                }
                else {
                    _this.setLoadingState(key, false);
                }
            }), map(function (data) {
                if (data === key) {
                    return 'Loading...';
                }
                return data;
            }));
        }
    };
    INDRAIbeAdminService.prototype.loadTranslationsEN = function (scopeId, moduleIds) {
        var _this = this;
        var language = "en";
        var modulesToLoad = new Array();
        moduleIds.forEach(function (moduleId) {
            if (!_this.loadedModulesEN.has(moduleId))
                modulesToLoad.push(moduleId);
        });
        if (modulesToLoad.length > 0) {
            return this.http
                .post(environment.api_url + "ibe/rest/scopes/" + scopeId + "/modules/translations/" + language, { modules: modulesToLoad })
                .subscribe(function (data) {
                data.forEach(function (moduleTranslations) {
                    if (_this.translationsENObj)
                        Object.assign(_this.translationsENObj, moduleTranslations);
                    else
                        _this.translationsENObj = moduleTranslations;
                });
                modulesToLoad.forEach(function (moduleId) {
                    if (!_this.loadedModulesEN.has(moduleId))
                        _this.loadedModulesEN.add(moduleId);
                });
                Array.from(_this.translationsENByKey.keys()).forEach(function (key) {
                    _this.translationsENByKey
                        .get(key)
                        .next(_this.getTranslationValue(key));
                });
            });
        }
    };
    INDRAIbeAdminService.prototype.reloadTranslationsEN = function (scopeId) {
        var _this = this;
        var language = "en";
        var moduleIds = Array.from(this.loadedModulesEN.values());
        return this.http
            .post(environment.api_url + "ibe/rest/scopes/" + scopeId + "/modules/translations/" + language, { modules: moduleIds })
            .subscribe(function (data) {
            data.forEach(function (moduleTranslations) {
                if (_this.translationsENObj)
                    Object.assign(_this.translationsENObj, moduleTranslations);
                else
                    _this.translationsENObj = moduleTranslations;
            });
            Array.from(_this.translationsENByKey.keys()).forEach(function (key) {
                return _this.translationsENByKey.get(key).next(_this.getTranslationValue(key));
            });
        });
    };
    INDRAIbeAdminService.prototype.getTranslationValueEN = function (key) {
        var _this = this;
        if (this.ibeadmin_debug)
            console.log("[IBE-Admin] Getting key " + key + " with language en");
        if (this.translationToggle.getValue()) {
            return key;
        }
        if (this.translationsENObj) {
            var keyValues = key.split(".");
            var result_2 = null;
            keyValues.forEach(function (value) {
                if (result_2)
                    result_2 = result_2[value];
                else
                    result_2 = _this.translationsENObj[value];
            });
            if (result_2) {
                if (this.ibeadmin_debug)
                    return "*" + result_2 + "*";
                else
                    return result_2.toString();
            }
            else {
                if (this.ibeadmin_debug)
                    console.warn('[IBE-Admin] Translation key not found: "' + key + '"');
                return key;
            }
        }
        else
            return key;
    };
    INDRAIbeAdminService.prototype.getLoadingState = function (key) {
        if (!this.loadingStates[key]) {
            this.setLoadingState(key, false);
        }
        return this.loadingStates[key].asObservable();
    };
    INDRAIbeAdminService.prototype.setLoadingState = function (key, isLoading) {
        if (!this.loadingStates[key]) {
            this.loadingStates[key] = new BehaviorSubject(isLoading);
        }
        else {
            this.loadingStates[key].next(isLoading);
        }
    };
    INDRAIbeAdminService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAIbeAdminService_Factory() { return new INDRAIbeAdminService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService), i0.inject(i3.INDRATranslationToggleService)); }, token: INDRAIbeAdminService, providedIn: "root" });
    return INDRAIbeAdminService;
}());
export { INDRAIbeAdminService };
